import React from "react";
import { Container } from "reactstrap";
import DemoNavbar from "components/Navbars/DemoNavbar.jsx";
import CardsFooter from "components/Footers/CardsFooter";
import ChildPageBanner from "./layout/ChildPageBanner";
import ConsumerMarketPanel from "./layout/ConsumerMarketPanel";
import BusinessImpactSection from "./layout/BusinessImpactSection";

const banner = {
  background: "banner/food.png",
  Title: "OUR BUSINESS",
  childTitle: "GLOBAL<br/>LIFESTYLE VENTURES",
  desktopCol: "8"
}

const introContent = {
  titleLines: [
    "CONNECTING CULTURE,",
    "COMMERCE, AND GLOBAL",
    "CONSUMER DEMAND",
  ],
  paragraphs: [
    `HMG’s Global Lifestyle Ventures division extends the Group’s trading and investment capabilities across high-growth consumer and lifestyle sectors, including premium food and beverage, proprietary brand development, entertainment, hospitality, and hotel and resort ventures.`,
    `Leveraging HMG’s international sourcing network, regional partnerships, and market access, we connect global brands, Korean cultural assets, premium consumer products, and destination concepts with retail, HORECA, entertainment, hospitality, and commercial channels across Asia and international markets.`,
  ],
  image: "content/food1clean.png",
  imageAlt: "HMG global food and beverage products",
  accentFrom: 1,
}

const imgTitle = [
  { number: "01", images: "content/food1.png", title: "PACKAGED PRODUCT", items: ["FROZEN FOOD", "DRY FOOD", "READY MEALS", "MEAL SOLUTIONS"] },
  { number: "02", images: "content/food2.png", title: "HORECA & FOOD SERVICE", items: ["HORECA DISTRIBUTION", "PREPARED FOODS", "SAUCES & CONDIMENTS", "CULINARY INGRADIENTS"] },
  { number: "03", images: "content/food3.png", title: "OEM / ODM", items: ["CONTRACT MANUFATURING", "PRODUCT DEVELOPMENT", "CUSTOM FORMULATION"] },
  { number: "04", images: "content/food4.png", title: "GLOBAL SOURCING & DISTRIBUTION", items: ["GLOBAL SOURCING", "IMPORT & EXPORT", "DISTRIBUTION CHANNELS", "SUPPLY-CHAIN MANAGEMENT"] },
  { number: "05", images: "content/private-brands-beer.jpeg", title: "ILON & ON PRIVATE BRANDS", items: ["ILON RICE WHISKY", "ON RICE SOJU", "ON RICE BEER", "ON SOJU RTD DRINKS", "WELLNESS RTD DRINKS"] },
  { number: "06", images: "content/food6.png", title: "AGRICULTURE, POULTRY & SEAFOOD", items: ["GRAINS & RICE", "FRUITS & VEGATABLES", "EDIBLE OILS & NUTS", "POULTRY & PROTEIN", "SEAFOOD & AQUACULTURE"] },
  { number: "07", images: "content/food7.png", title: "HOSPITALITY & F&B", items: ["RESTAURANTS", "BARS & LOUNGES", "DINING CONCEPTS", "BRAND EXPERIENCES"] },
  { number: "08", images: "content/food8.png", title: "FOOD TECHNOLOGY", items: ["FOOD PROCESSING", "FREEZING TECHNOLOGY", "PRODUCT R&D", "GLOBAL FOOD SECURITY"] },
]

const consumerMarketPanels = [
  {
    id: "food",
    title: "FOOD & BEVERAGE",
    description: "Delivering premium food and beverage solutions through global sourcing, manufacturing partnerships, and multi-channel distribution to meet evolving consumer demand worldwide.",
    image: "banner/food.png",
    bodyType: "food-grid",
  },
  {
    id: "entertainment",
    title: "ENTERTAINMENT AGENCY",
    description: "Connecting Korean talent and culture with global opportunities across entertainment, media, and brand partnerships.",
    image: "content/entertainment-agency.png",
    bodyType: "entertainment-showcase",
    supportingImage: "content/entertainment-agency-2.png",
    supportingImageAlt: "Entertainment agency talent, content, and global impact",
    body: {
      paragraphs: [
        "HMG operates in entertainment and talent management through strategic partnerships with Korean entertainment companies, artists, influencers, and brand partners.",
        "Our role is to connect Korean cultural talent with global commercial opportunities across entertainment, media, branding, endorsements, events, and business collaborations. We support talent-led brand expansion, overseas market representation, celebrity partnerships, and entertainment-driven consumer engagement. By combining consumer distribution with Korean cultural influence, HMG helps brands, talents, and commercial partners engage global audiences through culture-led business growth.",
      ],
      items: [
        "OVERSEAS TALENT REPRESENTATION",
        "CELEBRITY AND INFLUENCER PARTNERSHIPS",
        "BRAND ENDORSEMENTS AND CAMPAIGNS",
        "ENTERTAINMENT-DRIVEN PRODUCT LAUNCHES",
        "MEDIA & EVENT COLLABORATIONS",
      ],
    },
  },
  {
    id: "hospitality",
    title: "HOSPITALITY, HOTELS & RESORT DEVELOPMENT",
    description: "HMG develops and invests in distinctive hospitality, hotel, and resort concepts that unite destination value, cultural identity, and premium guest experiences.",
    image: "content/hospitality-ryokan.png",
    bodyType: "hospitality-showcase",
    supportingImage: "content/hospitality-2.png",
    supportingImageAlt: "Hospitality, hotels, and resort development",
    body: {
      paragraphs: [
        "Through strategic partnerships, brand development, and cross-border investment, we support projects from concept and positioning to development, market entry, and long-term commercial growth.",
      ],
    },
  },
];

const getLinkedPanelId = location => {
  const hash = location && location.hash
    ? location.hash.replace(/^#/, "")
    : "";

  return consumerMarketPanels.some(panel => panel.id === hash) ? hash : null;
};

const renderShowcaseVisual = panel => {
  if (!panel.supportingImage && !panel.image) {
    return null;
  }

  return (
    <div className="global-consumer-showcase-visual">
      <img
        src={panel.supportingImage || panel.image}
        alt={panel.supportingImageAlt || panel.title}
        loading="lazy"
        decoding="async"
      />
    </div>
  );
};

const renderPanelBody = panel => {
  if (panel.bodyType === "food-grid") {
    return (
      <div className="global-consumer-food-grid">
        {imgTitle.map(value => (
          <article
            className="global-consumer-food-card"
            key={value.title}
            style={{ backgroundImage: `url(${value.images})` }}
          >
            <div className="global-consumer-food-card-content">
              <p className="global-consumer-food-card-number">{value.number}</p>
              <h3>{value.title}</h3>
              {value.items && (
                <ul>
                  {value.items.map(item => <li key={item}>{item}</li>)}
                </ul>
              )}
            </div>
          </article>
        ))}
      </div>
    );
  }

  if (panel.bodyType === "entertainment-showcase") {
    return (
      <>
        <div className="global-consumer-entertainment-showcase">
          <div className="global-consumer-entertainment-copy">
            <h3>{panel.title}</h3>
            <p>{panel.description}</p>
            <ul>
              {panel.body.items.map(item => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          {renderShowcaseVisual(panel)}
        </div>
      </>
    );
  }

  if (panel.bodyType === "hospitality-showcase") {
    return (
      <>
        <div className="global-consumer-luxury-showcase">
          <div className="global-consumer-luxury-copy">
            <h3>{panel.title}</h3>
            <p>{panel.description}</p>
            {panel.body.paragraphs.map(paragraph => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
          {renderShowcaseVisual(panel)}
        </div>
      </>
    );
  }

  return (
    <div className="global-consumer-detail-body">
      {panel.body.paragraphs.map(paragraph => (
        <p key={paragraph}>{paragraph}</p>
      ))}
      {panel.body.items && (
        <ul>
          {panel.body.items.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

class GlobalLifestyleVentures extends React.Component {
  state = {
    expandedPanels: {},
    manuallyControlledHash: null,
  };

  togglePanel = panelId => {
    const linkedPanelId = getLinkedPanelId(this.props.location);
    const isExpanded = this.isPanelExpanded(panelId);

    this.setState(prevState => ({
      expandedPanels: {
        ...prevState.expandedPanels,
        [panelId]: !isExpanded,
      },
      manuallyControlledHash: linkedPanelId || prevState.manuallyControlledHash,
    }));
  };

  componentDidUpdate(prevProps) {
    const previousHash = prevProps.location && prevProps.location.hash;
    const currentHash = this.props.location && this.props.location.hash;

    if (previousHash !== currentHash && this.state.manuallyControlledHash) {
      this.setState({ manuallyControlledHash: null });
    }
  }

  isPanelExpanded = panelId => {
    const linkedPanelId = getLinkedPanelId(this.props.location);

    if (linkedPanelId && this.state.manuallyControlledHash !== linkedPanelId) {
      return linkedPanelId === panelId;
    }

    return Boolean(this.state.expandedPanels[panelId]);
  };

  render() {
    return (
      <>
        <DemoNavbar />
        <main className="food global-consumer-markets-page" ref="main">
          <ChildPageBanner banner={banner} />
          <section className="global-consumer-markets-body">
            <BusinessImpactSection {...introContent} />
            <Container>
              {consumerMarketPanels.map(panel => {
                const isPanelVisible = this.isPanelExpanded(panel.id);

                return (
                  <ConsumerMarketPanel
                    id={panel.id}
                    title={panel.title}
                    description={panel.description}
                    image={panel.supportingImage || panel.image}
                    bodyType={panel.bodyType}
                    expanded={isPanelVisible}
                    key={panel.id}
                    onToggle={this.togglePanel}
                  >
                    {renderPanelBody(panel)}
                  </ConsumerMarketPanel>
                );
              })}
            </Container>
          </section>
        </main>
        <CardsFooter />
      </>
    );
  }
}

export default GlobalLifestyleVentures;
